<template>
  <section class="news-content">
    <div class="main">
      <span class="main-title">{{news_main_title_}}</span>
      <div class="first" v-for="n in news" @click="detail(n.id)">
        <h3>{{n.title}}</h3>
        <div class="info">{{postedOn_}} <span>{{formatTime(n.update_time)}}</span></div>
        <div class="content" v-html="parseMarkdown(n.intro)"></div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
  import marked from 'marked'

  import { news } from '@/utils/api.js'
  import { formatTime } from '@/utils'
  import i18n from '@/i18n'

  export default {
    data () {
      return {
        news: []
      }
    },
    computed: {
      ...mapState(['v_locale']),
      ...mapGetters([]),
      ...i18n.map(['postedOn_', 'news_main_title_'])
    },
    methods: {
      ...mapMutations([]),
      ...mapActions([]),
      formatTime,
      parseMarkdown (val) {
        return marked(val)
      },
      detail (id) {
        this.$router.push(`/news_detail/${id}`)
      }
    },
    created () {
      news()
        .then((data) => {
          if (data && data.data) {
            this.news = data.data.reverse()
          }
        })
        .catch((err) => {
          this.$emit('msg', {
            msg: err.message,
            type: 'error',
            delay: 2000
          })
        })
    }
  }
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/news.vue